import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../common/withRouter';
import { ButtonOBSOLETED } from '../../web.common';


const AddEntityButton = ({ to, options, history }) => {
  if (to && options) {
    throw new Error('AddEntityButton: specify either a location or a list');
  }
  else if (to) {
    return (<Link to={to}><span className='add-entity-button' /></Link>);
  }
  else if (options) {
    return (
      <span className='add-entity-button'>
        <div className='show-on-hover'>
          <ul>
            {
              Object.entries(options).map(([name, link]) => (
                <React.Fragment>
                  <ButtonOBSOLETED
                    onClick={() => {
                      history.push(link);
                    }}
                    buttonContent={name}
                    ariaLabel=''
                    ariaExpanded={false}
                    disabled={false}
                    sameTextAndIconColor
                  />
                </React.Fragment>
              ))
            }
          </ul>
        </div>
      </span>
    );
  }
  else {
    throw new Error('AddEntityButton: specify either a location or a list');
  }
};

export default withRouter(AddEntityButton);